import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import SnackBarContextProvider from "./context/snackbar-context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <SnackBarContextProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </SnackBarContextProvider>
);
